// The ONE "where is this visitor" signal (#4967, ADR 0059). Every surface
// that varies by market imports resolveVisitorRegion from here: the landing
// page's Master's abroad section now, the rupee pricing next (#4966).
//
// What the stack gives us: nothing carries a country. Firebase Hosting serves
// the page statically, and the Cloud Functions run with no load balancer in
// front, so no country header exists to read (the security review of #2600
// found the same). The browser's own time zone is the hint: a visitor whose
// time zone is Asia/Kolkata is treated as in India. It is a hint, not a
// location: no prompt, nothing stored, nothing sent to a third party. The
// page posts only the region code it resolved.
//
// QA: ?region=in (or ?region=us) on the URL overrides the time zone for that
// page view. The override changes only the region; whatever the region
// unlocks is still behind its feature flag (india_masters).

import { regionForCode, regionForTimeZone, DEFAULT } from '../config/regions';

export const REGION_PARAM = 'region';

/** The browser's IANA time zone, or null where it cannot be read. */
export function browserTimeZone() {
    try {
        return Intl.DateTimeFormat().resolvedOptions().timeZone || null;
    } catch {
        return null;
    }
}

/**
 * {region, source}: the region strategy (config/regions.js) and how it was
 * decided: 'override' (?region=), 'timezone' (the browser's zone matched a
 * region) or 'default'. `search` and `timeZone` are injectable for tests;
 * they default to the live page.
 */
export function resolveVisitorRegion({ search, timeZone } = {}) {
    let q = search;
    if (q === undefined) {
        try { q = window.location.search; } catch { q = ''; }
    }
    try {
        const forced = regionForCode(new URLSearchParams(q || '').get(REGION_PARAM));
        if (forced) return { region: forced, source: 'override' };
    } catch { /* an unreadable query is no override */ }
    const tz = timeZone === undefined ? browserTimeZone() : timeZone;
    const region = regionForTimeZone(tz);
    return { region, source: region === DEFAULT ? 'default' : 'timezone' };
}
